<template>
  <div class="commonDialogBody">
    <BillsDepartmenDialogone @AllData="getMsgFormSon"  ref="BillsDepartmenDialogone" />
    <el-dialog
        :close-on-click-modal='false'
        :title="title"
         :visible.sync="dialogVisible"
        width="50%"
        :destroy-on-close="true"
        :before-close="handleClose">
        <div style="width:70%;margin-left:5%;">
<el-form :label-position="labelPosition" label-width="120px" :model="formLabelAlign" style="width:75%;" >
     <el-form-item :label="formLabelAlign.obj.mangroupName" >
    <el-select  clearable v-model="value" placeholder="请选择" @change="ChargeBillManTree">
    <el-option v-for="item in options" :key="item.id" :label="item.label" :value="item.value">
    </el-option>
  </el-select>
</el-form-item>
     <el-form-item :label="formLabelAlign.obj.department" >
    <el-cascader
    v-model="valueone"
    :props="{value:'officeId',label:'officeName'}"
    :options="optionsone"
    @change="optionsoneChange"></el-cascader>
        <el-button @click="handleChange">配置</el-button>
</el-form-item>

   <el-form-item :label="formLabelAlign.obj.remarks" >
       <el-input v-model="formLabelAlign.remarks" size="small"></el-input>
    </el-form-item>
</el-form>
</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="modification()" v-debounce>确 定 </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import BillsDepartmenDialogone from "../common/BillsDepartmenDialogone.vue";
export default {
 components: {BillsDepartmenDialogone},
  name: "BillsDepartmenDialog",
  data() {
    return {
    optionsT:{},
     options:[],
    value:"",
    optionsone: [],
    valueone: '',
    dialogVisible: false,
    title:"标题",
    labelPosition:'right',
    formLabelAlign:{},
    type:"",
    department:"",


        mangroupId:"",
    };
  },
  methods: {
    optionsoneChange(){
    },
    handleChange(){
       this.$refs.BillsDepartmenDialogone.title = "配置";
      this.$refs.BillsDepartmenDialogone.dialogVisi = true;
    },
    chooseNode(){
    },
    ChargeBillManTree(){
        for(let val of this.options){
          if(this.value == val.value){
            this.mangroupId = val.value
            this.mangroupName = val.label
          }
        }
    },
    modification(){
        if(this.title == "修改"){
          let obj = {
              "id":this.formLabelAlign.id,
              "mangroupId":this.formLabelAlign.mangroupId,
              "mangroupName":this.formLabelAlign.mangroupName,
              "officeId":this.optionsone[0].officeId,
              "officeName":this.optionsone[0].officeName,
              "remarks":this.formLabelAlign.remarks,
          }
          if(obj.mangroupId == undefined || obj.mangroupId == ""){
            this.$message({
            type: "warning",
            message: "请完善必填项"
          })
          }else if(obj.officeId == undefined || obj.officeId == ""){
            this.$message({
            type: "warning",
            message: "请完善必填项"
          })
          }else{
        this.$http.post(this.$requestUrl.POST_BILL_DEPARTADD,obj).then((res) => {
      let result = res.data;
              if (200 === result.code) {
                this.dialogVisible = false
  this.$emit("Visible",false)
                this.$message({
                              type: 'success',
                              message: '修改成功!'
                          });
              } else {
                this.$message.error(result.msg)
              }
              }).catch(() => {
                this.$message.error(this.$errorMessage.SEVER_ERROR)
              })
          }
        }else if(this.title == "添加"){
            // console.log("添加")
               let obj = {
              "mangroupId":this.mangroupId,
              "mangroupName":this.mangroupName,
              "officeId":this.optionsone[0].officeId,
              "officeName":this.optionsone[0].officeName,
              "remarks":this.formLabelAlign.remarks,
                }
          // console.log(obj)
          if(obj.mangroupId == undefined || obj.mangroupId == ""){
            this.$message({
            type: "warning",
            message: "请完善必填项"
          })
          }else if(obj.officeId == undefined || obj.officeId == ""){
            this.$message({
            type: "warning",
            message: "请完善必填项"
          })
          }else{
        this.$http.post(this.$requestUrl.POST_BILL_DEPARTADD,obj).then((res) => {
      let result = res.data;
               
              if (200 === result.code) {
                this.dialogVisible = false
                  this.$emit("Visible",false)
                this.$message({
                              type: 'success',
                              message: '添加成功!'
                          });
              } else {
                this.$message.error(result.msg)
              }
              }).catch(() => {
                this.$message.error(this.$errorMessage.SEVER_ERROR)
              })
          }
        }


    },
    getMsgFormSon(data){
        delete data.children 
        let arr = []
        arr.push(data)
        this.optionsone = arr

        let array = []
        array.push(data.officeId)
        this.valueone = array
    },
    handleClose(done) {
      this.dialogVisible = false
    },
   getUserOffice() {
   let obj = {
         "treeGroup":1,
          "officeType":"1",
          "grade":"1"
       }
      this.$http.post(this.$requestUrl.GET_USER_OFFICE_TREE,obj).then((res) => {
        let data = res.data.data;
         
          this.osData = data
      }).catch(() => {
        this.$message.error(this.$errorMessage.SEVER_ERROR)
      })
    }
  },
  mounted() {
    this.getUserOffice();

  },
    //页面渲染之前
  beforeMount() {
       if(this.formLabelAlign.obj == undefined){
          let obj = {
            "department":"票据组归属部门",
            "mangroupName":"票据管理组",
            "remarks":"备注信息",
          }
          this.osData = []
      this.formLabelAlign.obj = obj
    }
  },
}
</script>

<style scoped lang="scss">
// .commonDialogBody {

// }
</style>